export enum AutoNotePageKinds {
  // 全て続紙へ
  All = 1,
  // 超過分を続紙へ
  Excess = 2,
}
